var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-8" },
      [
        _c("q-input", {
          staticClass: "no-shadow",
          attrs: {
            name: "qbSysChargeId",
            "hide-underline": "",
            "inverted-light": "",
            color: _vm.inputBgColor
          },
          on: { input: _vm.updateParent },
          model: {
            value: _vm.qbSysChargeId,
            callback: function($$v) {
              _vm.qbSysChargeId = $$v
            },
            expression: "qbSysChargeId"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c("q-btn", {
          staticClass: "full-width",
          attrs: {
            label: "View/Edit Payment",
            icon: "receipt",
            color: "secondary",
            disable: !_vm.qbSysChargeId
          },
          on: {
            click: function($event) {
              return _vm.externalLink(_vm.qbSysChargeId)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }